import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useSite } from "@/context/SiteContext";
import { LogOut, LayoutGrid, Settings as SettingsIcon, ExternalLink } from "lucide-react";

export default function AdminLayout({ children }) {
  const { logout } = useAuth();
  const { refresh } = useSite();
  const navigate = useNavigate();
  const loc = useLocation();

  const doLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  const nav = [
    { to: "/admin", label: "Fleet", icon: LayoutGrid },
    { to: "/admin/settings", label: "Settings", icon: SettingsIcon },
  ];

  return (
    <div className="min-h-screen bg-surface">
      <header className="sticky top-0 z-40 border-b border-border bg-white">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5">
          <div className="flex items-center gap-6">
            <span className="font-heading text-lg font-black tracking-tighter">
              EAZY<span className="text-[#00E676]">CAR</span>TRACK <span className="text-xs font-semibold text-zinc-400">ADMIN</span>
            </span>
            <nav className="hidden gap-1 sm:flex">
              {nav.map((n) => (
                <Link key={n.to} to={n.to} data-testid={`admin-nav-${n.label.toLowerCase()}`}
                  className={`flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold ${loc.pathname === n.to ? "bg-ink text-white" : "text-zinc-600 hover:bg-surface"}`}>
                  <n.icon className="h-4 w-4" /> {n.label}
                </Link>
              ))}
            </nav>
          </div>
          <div className="flex items-center gap-2">
            <a href="/" target="_blank" rel="noreferrer" className="hidden items-center gap-1.5 rounded-full border border-border px-4 py-2 text-sm font-semibold sm:inline-flex">
              <ExternalLink className="h-4 w-4" /> View Site
            </a>
            <button onClick={doLogout} data-testid="admin-logout" className="inline-flex items-center gap-1.5 rounded-full border border-border px-4 py-2 text-sm font-semibold hover:bg-white">
              <LogOut className="h-4 w-4" /> Logout
            </button>
          </div>
        </div>
        <nav className="flex gap-1 border-t border-border px-5 py-2 sm:hidden">
          {nav.map((n) => (
            <Link key={n.to} to={n.to} className={`flex-1 rounded-full px-3 py-2 text-center text-sm font-semibold ${loc.pathname === n.to ? "bg-ink text-white" : "text-zinc-600"}`}>{n.label}</Link>
          ))}
        </nav>
      </header>
      <main className="mx-auto max-w-7xl px-5 py-8">{children}</main>
    </div>
  );
}
